import { render, staticRenderFns } from "./InputValueWithUnit.vue?vue&type=template&id=6356e45e"
import script from "./InputValueWithUnit.vue?vue&type=script&lang=js"
export * from "./InputValueWithUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports